module.exports = __webpack_public_path__ + "img/brand-2.8fdbd67f.jpg";